// extracted by mini-css-extract-plugin
export default {"defaultMargin":"GoodsCodeCreatorModal_defaultMargin__7zrsX"};